import { Component } from "react";
import { PriceDisplay } from "./PriceDisplay.js";
import { calculatePrice } from "./CurrencySelector.js";
import ExportLink from "./ExportLink.js";

export class SelectSection extends Component {
	
	render() {
		
		const options = this.props.options;
		const appState = this.props.appState;
		const thisStyle = appState.selectedStyle;
		const styleData = options[thisStyle];
		const thisVariant = appState.selectedVar && styleData.variants ?
			styleData.variants[appState.selectedVar] :
			null;
		
		return (
			<div className="settings-area">

				<PriceDisplay
					options={ options }
					price={ appState.price }
					rate={appState.rate}
					currency={ appState.currency }
				/>
				
				<SelectMenu
					label="Style"
					attribute="selectedStyle"
					optionList={
						Object.keys(options).map(
							(val, i) => {
								return {
									"index": i,
									"label": options[val].name,
									"value": val
								};
							}
						)
					}
					value={appState.selectedStyle}
					onChange={this.props.handleChange}
				/>
				
				{
					thisStyle ?
					(<SelectMenu
						label="Variant"
						attribute="selectedVar"
						optionList={
							Object.keys(options[thisStyle].variants)
								.map((val, i)=>{
									return {
										"index": i,
										"label": options[thisStyle].variants[val].name,
										"value": val
									};
								})
						}
						value={appState.selectedVar}
						onChange={this.props.handleChange}
					/>) : ""
				}
				
				{
					thisVariant && thisVariant.addons ? (
						<>
							<h2>Addons</h2>
							<ul className="addons">{
								thisVariant.addons.map( addon => <li>
									{addon.name}: <span className="price" key={addon.name}>
										{calculatePrice(addon.price, appState.currency, appState.rate)}
									</span>
								</li> )
							}</ul>
						</>
					) : ""
				}

				{
					thisVariant ? <div className="settings-wrapper"><ExportLink style={options[thisStyle].name} variant={thisVariant.name} basePrice={appState.price} /></div> : null
				}
				
			</div>
		);
	}
	
}

export class SelectMenu extends Component {
	constructor(props) {
		super(props);
		this.mapOptionsToElements = this.mapOptionsToElements.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	
	render() {
		return (
		<div className={`${this.props.className || "settings-wrapper"}`}>
			<h2>{this.props.label}</h2>
			<select
				className="menu"
				onChange={ this.handleChange }
				value={ this.props.value === null ? "" : this.props.value }
			>
				<option value="">Select one...</option>
				{ this.mapOptionsToElements(this.props.value) }
			</select>
		</div>
		);
	}
	
	mapOptionsToElements(selectedValue) {
		let optionList = this.props.optionList.map((val, i)=>{
			return <SelectOption
				key={ val+"-"+i }
				label={val.label}
				value={val.value}
				selected={val.value === selectedValue}
			/>
		});
		return optionList;
	}
	
	handleChange(e){
		this.props.onChange(this.props.attribute, e.target.value);
	}
	
}

export class SelectOption extends Component {
	render() {
		return <option className="menu-option" value={this.props.value}>{this.props.label}</option>;
	}
}